import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { PageHeader } from '@/components/ui/page-header'
import { KpiCard } from '@/components/dashboard/kpi-card'
import { Building2, Cloud, Users, RefreshCw } from 'lucide-react'

interface AdminStats {
  tenants: { total: number; active: number }
  m365Tenants: { total: number }
  m365Users: { total: number }
  syncJobsToday: { total: number; failed: number }
}

export function AdminPage() {
  const { data: stats } = useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: () => api.get<AdminStats>('/admin/stats'),
  })

  return (
    <div className="space-y-6">
      <PageHeader title="Panel de Administracion" description="Metricas globales de la plataforma ROI365" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        <KpiCard
          label="Clientes activos"
          value={stats?.tenants.active ?? 0}
          subtitle={`${stats?.tenants.total ?? 0} total`}
          icon={Building2}
          accentColor="var(--color-brand-primary)"
        />
        <KpiCard
          label="Tenants M365"
          value={stats?.m365Tenants.total ?? 0}
          icon={Cloud}
          accentColor="var(--color-brand-secondary)"
        />
        <KpiCard
          label="Usuarios M365"
          value={(stats?.m365Users.total ?? 0).toLocaleString('es-ES')}
          icon={Users}
          accentColor="var(--color-brand-accent-1)"
        />
        <KpiCard
          label="Syncs hoy"
          value={stats?.syncJobsToday.total ?? 0}
          subtitle={stats?.syncJobsToday.failed ? `${stats.syncJobsToday.failed} fallidos` : 'Todos OK'}
          icon={RefreshCw}
          accentColor={stats?.syncJobsToday.failed ? 'var(--color-error)' : 'var(--color-success)'}
        />
      </div>
    </div>
  )
}
